export default {
  model: [
    {
      label: 'Data inicial',
      field: 'consulting_start_date',
      type: 'date'
    },
    {
      label: 'Data final',
      field: 'consulting_end_date',
      type: 'date',
    },
    {
      label: 'Quantidade',
      field: 'consulting_qtd',
      type: 'text'
    }
  ]
}